<template>
  <div>
    <title-bar :title-stack="titleStack"/>
    <hero-bar>
      Editar
    </hero-bar>
    <section class="section is-main-section">
      <question-item
        v-for="(item, index) in itemsQuestion"
        v-bind:key="item.id"
        v-bind:id="item.id"
        v-bind:index="index"
        v-bind:newItem="item.newItem"
        v-bind:premise="item.premise"
        v-bind:nameHeader="item.name_header"
        v-bind:typeAnswer="item.type_answer"
        v-bind:allTypesAnswer="typesAnswer"
        />
      <b-field>
        <div class="control">
          <b-button class="button-secondary" v-on:click="createItem()">
            Nueva Pregunta
          </b-button>
        </div>
      </b-field>
      <b-loading :is-full-page="true" :active.sync="isLoading"/>
    </section>
  </div>
</template>
<script>
import HeroBar from '@/components/HeroBar'
import TitleBar from '@/components/TitleBar'
import QuestionRepository from '@/services/QuestionRepository'
import TypesAnswerRepository from '@/services/TypesAnswerRepository'
import QuestionItem from '@/components/question/QuestionItem'

export default {
  name: 'QuestionsEdit',
  components: {
    TitleBar,
    HeroBar,
    QuestionItem
  },
  data () {
    return {
      itemsQuestion: null,
      typesAnswer: [],
      isLoading: true
    }
  },
  computed: {
    titleStack () {
      return [
        'Admin',
        'Herramientas'
      ]
    }
  },
  mounted () {
    TypesAnswerRepository.getTypesAnswerResponses()
      .then((r) => {
        for (let i = 0; i < r.data.length; i++) {
          this.typesAnswer.push({
            key: r.data[i].key,
            value: r.data[i].value
          })
        }
      })

    QuestionRepository.getQuestionsResponses()
      .then((r) => {
        this.isLoading = false
        if (r.data) {
          this.itemsQuestion = r.data
        }
      }).catch(e => {
        if (e.response.status === 401) {
          this.$router.push('login')
        } else {
          this.isLoading = false
          this.$buefy.toast.open({
            message: `Error: ${e.message}`,
            type: 'is-danger'
          })
        }
      })
  },
  methods: {
    createItem () {
      const item = {}
      item.premise = 'Escriba su pregunta'
      item.name_header = 'Nombre del header'
      item.type_answer = 0
      item.newItem = true

      this.itemsQuestion.push(item)
    }
  }
}
</script>
